import { TableauLocalizedStrings } from "../../Strings";

export function showMaintenancePage(
  doc: Document,
  strings: TableauLocalizedStrings,
  serverName: string
) {
  const renderer = new MaintenancePageRenderer(doc, strings, serverName);
  doc.body.replaceChildren(renderer.getBodyContents());

  doc
    .querySelectorAll('style,link[rel="stylesheet"]')
    .forEach((element) => element.remove());
}

class MaintenancePageRenderer {
  doc: Document;
  strings: TableauLocalizedStrings;
  serverName: string;

  constructor(
    doc: Document,
    strings: TableauLocalizedStrings,
    serverName: string
  ) {
    this.doc = doc;
    this.strings = strings;
    this.serverName = serverName;
  }

  public getBodyContents() {
    const heading = this.doc.createElement("h1");
    heading.innerHTML = this.strings.MaintenanceMessage(this.serverName);

    return heading;
  }
}
